console.group("inicializando o pack css das gems do app")

  console.log("inicializando componentes da uxkit")
  
  import '/var/www/apps/sfg/engines/ux_kit19/app/frontend/util/css/components/user.scss';

console.groupEnd();
